// Foundations
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import NavigationBar from "./components/NavigationBar";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import About from "./components/About";
import Works from "./components/Works";
import Events from "./components/Events";

const App = () => {
  return (
    <Router>
      <div>
        <NavigationBar />
        <Routes>
          <Route path="/" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/my-work" element={<Works />} />
          <Route path="/events" element={<Events />} />
        </Routes>
        {/*<Footer />*/}
      </div>
    </Router>
  );
};

export default App;
